import React from 'react';

const ContractDisplay = ({ customerData, packData, deposit, protectActive = false, protectFee = 0 }) => {
  const effDeposit = (deposit !== undefined && deposit !== null) ? deposit : packData?.price;
  const today = new Date().toLocaleDateString('fr-FR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });

  const customerName = customerData?.company 
    ? customerData.company 
    : `${customerData?.firstName || ''} ${customerData?.lastName || ''}`.trim();

  const customerAddress = [
    customerData?.address,
    customerData?.postalCode,
    customerData?.city
  ].filter(Boolean).join(', ');

  return (
    <div className="prose prose-sm max-w-none text-slate-700 leading-relaxed">
      <h2 className="text-lg font-bold text-center text-slate-900 mb-6">
        CONTRAT DE LOCATION D'ÉCRANS LED
      </h2>

      {/* Parties */}
      <div className="mb-6 p-4 bg-slate-50 rounded-lg">
        <p className="font-semibold mb-3">ENTRE LES SOUSSIGNÉ(E)S :</p>
        <p className="mb-4 text-sm">
          La société <strong>KF DIFFUSION</strong>, Société à responsabilité limitée, au capital de 10 000 €, 
          dont le siège se situe 65 Avenue Jacqueline Auriol 13700 MARIGNANE, immatriculée au RCS de 
          AIX EN PROVENCE sous le numéro 820 956 076, représentée par ses Co-Gérants Monsieur Yohan KOURDJEE 
          et Monsieur Thierry FREDJ.
          <br />Ci-après dénommée, « <strong>le Bailleur</strong> ».
        </p>
        <p className="text-center mb-4 font-semibold">D'UNE PART,</p>
        <p className="mb-4 text-sm">
          {customerData?.company ? (
            <>
              La société <strong>{customerData.company}</strong>, représentée par {customerData.firstName} {customerData.lastName}, 
              domiciliée {customerAddress}, email : {customerData.email}, téléphone : {customerData.phone}.
            </>
          ) : (
            <>
              Madame/Monsieur <strong>{customerData?.firstName} {customerData?.lastName}</strong>, 
              demeurant {customerAddress}, email : {customerData?.email}, téléphone : {customerData?.phone}.
            </>
          )}
          <br />Ci-après dénommé(e), « <strong>le Preneur</strong> ».
        </p>
        <p className="text-center font-semibold">D'AUTRE PART,</p>
        <p className="mt-4 text-sm text-slate-600">
          Le Bailleur et le Preneur sont collectivement dénommés les « Parties » et individuellement dénommés une « Partie ».
        </p>
      </div>

      {/* Pack Info */}
      {packData && (
        <div className="mb-6 p-4 bg-[#DFFF00]/10 border border-[#DFFF00]/30 rounded-lg">
          <p className="font-semibold text-slate-900 mb-2">Biens loués :</p>
          <ul className="list-disc pl-5 mb-2 text-sm">
            <li><strong>{packData.name}</strong> - Surface : {packData.surface}</li>
          </ul>
          <p className="text-sm"><strong>Loyer mensuel :</strong> {packData.price}€ TTC/mois</p>
          {protectActive && (
            <p className="text-sm"><strong>Forfait Couverture Protect + :</strong> {protectFee}€ TTC/mois</p>
          )}
          <p className="text-sm"><strong>Dépôt de garantie :</strong> {effDeposit}€ TTC{protectActive ? ' (caution réduite — Couverture Protect +)' : ''}</p>
        </div>
      )}

      <p className="text-sm italic mb-6">
        IL A ÉTÉ EXPOSÉ ET CONVENU CE QUI SUIT :<br/>
        Le présent contrat est régi par les articles 1713 et suivants du Code civil relatifs à la location.
      </p>

      {/* Article 1 */}
      <h3 className="font-bold text-slate-900 mt-6 text-base">Article 1 - Objet du contrat</h3>
      <p className="text-sm mb-2">
        Le Bailleur loue au Preneur, qui accepte, les biens mobiliers suivants (ci-après « les Biens ») : 
        <strong> {packData?.name || 'Pack LED'} ({packData?.surface || 'surface définie'})</strong>.
      </p>
      <p className="text-sm mb-2">
        <strong>Dispositif de localisation :</strong> Afin d'assurer la protection des Biens contre le vol, la perte, la disparition ou leur non-restitution en cas d'impayé ou de résiliation du contrat, les Biens peuvent être équipés d'un dispositif de localisation électronique. Le Preneur reconnaît être informé de cet équipement et s'engage à ne pas tenter de le neutraliser, sous peine des sanctions prévues à l'article 10. Ce dispositif :
      </p>
      <ul className="list-disc pl-5 text-sm mb-2">
        <li>Ne permet aucune captation sonore, visuelle ou surveillance des personnes ;</li>
        <li>N'a pour finalité exclusive que la protection et la récupération des Biens ;</li>
        <li>Ne fait l'objet d'aucune exploitation commerciale des données collectées.</li>
      </ul>
      <p className="text-sm mb-2">
        Les données de localisation sont traitées par le Bailleur sur le fondement de son intérêt légitime à la protection de ses actifs, conformément au Règlement (UE) 2016/679 (RGPD) et à la loi Informatique et Libertés. Les données sont conservées pendant la durée du contrat et supprimées dans un délai maximum de 30 jours suivant la restitution effective des Biens.
      </p>
      <p className="text-sm mb-2">
        Le Preneur reconnaît avoir été informé de l'existence de ce dispositif et s'engage à ne pas le neutraliser, le retirer, l'endommager ou en entraver le fonctionnement. Toute tentative de neutralisation constituera un manquement grave pouvant entraîner la résiliation immédiate du contrat et l'application des sanctions prévues à l'article 10.
      </p>
      <p className="text-sm mb-2">
        En cas d'impayé persistant, de non-restitution ou de disparition des Biens, le Bailleur pourra utiliser les données de localisation exclusivement aux fins de récupération du matériel, y compris par voie judiciaire si nécessaire.
      </p>
      <p className="text-sm">
        <strong>Destination :</strong> Les Biens sont loués à usage exclusivement professionnel sans transfert de propriété, pour une durée déterminée.
      </p>

      {/* Article 2 */}
      <h3 className="font-bold text-slate-900 mt-6 text-base">Article 2 – Durée & reconduction</h3>
      <p className="text-sm mb-2">
        Le présent contrat est conclu pour une durée minimale d'un (1) mois à compter de la date de mise à disposition des Biens. Il est renouvelable par tacite reconduction pour des périodes successives d'un (1) mois, sauf résiliation.
      </p>
      <p className="text-sm mb-2 font-semibold">
        Tout mois entamé est intégralement dû.
      </p>
      <p className="text-sm mb-2">
        À l'échéance de la durée initiale ou d'une période de reconduction, chacune des parties peut résilier le contrat en respectant un préavis de quinze (15) jours, le Preneur pourra le faire par l'intermédiaire de la plateforme de réservation en ligne mise à disposition par le Bailleur dans la rubrique « résiliation ».
      </p>
      <p className="text-sm mb-2">
        La résiliation prend effet à l'issue du préavis. Toute demande de restitution devra être formulée au moins quinze (15) jours avant la fin du mois contractuel souhaité. Le Bailleur organisera le passage du transporteur le dernier jour du mois contractuel. À défaut de respect de ce délai, le mois suivant sera automatiquement facturé et débité. Si le Preneur ne met pas les Biens à disposition du transporteur dans un délai de deux (2) jours ouvrés suivant la date convenue, le mois suivant sera automatiquement facturé.
      </p>

      {/* Article 3 */}
      <h3 className="font-bold text-slate-900 mt-6 text-base">Article 3 - Loyer et modalités de paiement</h3>
      <p className="text-sm mb-2">
        Le loyer est forfaitaire et fixé à <strong>{packData?.price || 'X'}€ TTC par mois</strong>.
      </p>
      <p className="text-sm">
        Le loyer est payable d'avance, mensuellement, par prélèvement automatique. Tout retard de paiement entraînera de plein droit des pénalités de retard au taux de 4 %, sans préjudice d'une éventuelle résiliation pour faute.
      </p>

      {/* Article 4 */}
      <h3 className="font-bold text-slate-900 mt-6 text-base">Article 4 – Dépôt de garantie</h3>
      <p className="text-sm mb-2">
        1. Le Locataire verse au Bailleur, à la signature du présent contrat, un dépôt de garantie d'un montant de <strong>{effDeposit || 'X'}€</strong>, {protectActive ? "dont le montant est réduit dans le cadre de l'avenant Couverture Protect +" : "correspondant à un (1) mois de loyer"}. Ce dépôt est versé par paiement en ligne au moment de la commande. Le dépôt de garantie ne produit aucun intérêt.
      </p>
      <p className="text-sm mb-2">
        2. Le dépôt de garantie garantit l'exécution par le Locataire de toutes ses obligations contractuelles, notamment :
      </p>
      <ul className="list-disc pl-5 text-sm mb-2">
        <li>Le paiement des loyers, charges et accessoires ;</li>
        <li>La restitution de l'équipement en bon état d'usage, tenant compte de la vétusté normale, à l'issue du contrat ou en cas de résiliation anticipée, comme constaté par un état des lieux contradictoire établi par un huissier ou les parties.</li>
      </ul>
      <p className="text-sm mb-2">
        3. Le Bailleur conserve le dépôt de garantie jusqu'à la fin du contrat. À l'expiration ou à la résiliation, le Bailleur restitue le dépôt au Locataire dans un délai maximum de 30 jours suivant la restitution effective de l'équipement et l'apurement de toutes dettes locatives, déduction faite le cas échéant :
      </p>
      <ul className="list-disc pl-5 text-sm mb-2">
        <li>Des loyers, charges ou accessoires impayés ;</li>
        <li>Des frais de remise en état excédant l'usure normale (sur justificatifs détaillés fournis au Locataire) ;</li>
        <li>Des coûts de réparation ou de remplacement dus à une dégradation imputable au Locataire.</li>
      </ul>
      <p className="text-sm mb-2">
        4. En cas de déduction, le Bailleur notifie au Locataire, par courriel avec accusé de réception ou tout moyen laissant trace écrite, le détail des sommes retenues, accompagné des justificatifs (factures, devis…). Toute contestation est soumise à la juridiction compétente désignée ci-après.
      </p>
      <p className="text-sm mb-2">
        5. Aucun intérêt ne produit sur le dépôt de garantie. Le dépôt ne peut être imputé sur les derniers loyers dus. En cas de renouvellement du contrat, un nouveau dépôt pourra être exigé si justifié.
      </p>
      <p className="text-sm">
        6. Le dépôt de garantie devra impérativement être versé par virement bancaire ou paiement en ligne sécurisé et être effectivement encaissé avant toute mise à disposition des Biens. Aucune garantie alternative ne pourra s'y substituer.
      </p>

      {/* Article 5 */}
      <h3 className="font-bold text-slate-900 mt-6 text-base">Article 5 – Livraison, exploitation et restitution des Biens</h3>
      
      <p className="text-sm font-semibold mt-3">5.1. Livraison</p>
      <p className="text-sm mb-2">
        Les Biens seront livrés au Preneur à l'adresse <strong>{customerAddress || 'indiquée'}</strong> en bon état. Les Biens sont préparés et contrôlés par le Bailleur ou son représentant avant expédition. Un état descriptif et inventaire détaillé figurant en Annexe n°2 est établi lors de la préparation. Les risques sont transférés au Preneur à compter de la remise des Biens au transporteur désigné par le Bailleur.
      </p>
      <p className="text-sm mb-2">
        À la réception, le Preneur est tenu de vérifier l'état apparent des colis et d'émettre, le cas échéant, toute réserve précise et motivée sur le bon de livraison du transporteur en cas d'avarie, colis endommagé ou ouvert. Le contrôle fonctionnel des Biens devra être effectué par le Preneur dans un délai de quarante-huit (48) heures suivant la réception. Toute non-conformité, élément manquant ou dysfonctionnement devra être notifié par écrit au Bailleur dans ce délai, accompagné de tout élément justificatif (photographies, vidéos, description précise). À défaut de notification dans ce délai, les Biens seront réputés conformes et en bon état de fonctionnement lors de leur réception.
      </p>
      <p className="text-sm mb-2">
        À l'expiration ou à la résiliation du contrat, le Preneur restituera les Biens au Bailleur en bon état, compte tenu de l'usure normale, aux frais du Preneur. Un procès-verbal de restitution (Annexe 2) sera établi.
      </p>

      <p className="text-sm font-semibold mt-3">5.2. Exploitation</p>
      <p className="text-sm mb-2">
        Le Preneur s'engage à exploiter le bien loué exclusivement dans le cadre de son activité professionnelle. L'adresse de livraison du bien, telle que précisée à la clause de livraison du présent contrat, peut différer de l'adresse d'exploitation professionnelle. En cas de différence, le Preneur demeure responsable du transport et de la mise en place du bien à son lieu d'exploitation professionnel. Le bien ne pourra en aucun cas être utilisé à titre personnel ou pour une activité autre que celle déclarée au présent contrat.
      </p>

      <p className="text-sm font-semibold mt-3">5.3. Restitution</p>
      <p className="text-sm mb-2">
        À la restitution, un état des Biens sera établi par le Bailleur ou son représentant. Toute dégradation, élément manquant ou dysfonctionnement non signalé lors de la réception sera présumé imputable au Preneur, sauf preuve contraire.
      </p>

      <p className="text-sm font-semibold mt-3">5.4. Frais de transport</p>
      <p className="text-sm mb-2">
        Les frais d'expédition initiale des Biens sont pris en charge par le Bailleur.
      </p>

      <p className="text-sm font-semibold mt-3">5.5. Conditions de retour et conditionnement</p>
      <p className="text-sm mb-2">
        Les frais de retour des Biens sont à la charge exclusive du Preneur et seront facturés lors de la demande de restitution, en fonction du département de collecte. Le Preneur s'engage à conserver les palettes, protections et sangles fournis lors de la livraison. Les Biens devront impérativement être retournés sur les palettes d'origine et fixés à l'aide des sangles fournies. Tout défaut d'emballage ou conditionnement inadapté ayant entraîné des dommages constatés à la réception chez le Bailleur sera facturé au Preneur.
      </p>
      <p className="text-sm mb-2">
        Les Biens devront être restitués propres, complets et dans le même état que lors de la livraison. Des frais de nettoyage pourront être appliqués le cas échéant. Tout article manquant ou détérioré sera facturé au Preneur conformément aux conditions tarifaires en vigueur.
      </p>
      <p className="text-sm font-semibold">
        En cas de dégradation constatée lors de la restitution :
      </p>
      <ul className="list-disc pl-5 text-sm mb-2">
        <li>19 € HT par LED endommagée ;</li>
        <li>19 € HT par circuit imprimé remplacé.</li>
      </ul>
      <p className="text-sm">Ces montants constituent une évaluation forfaitaire des frais de remise en état.</p>

      {/* Article 6 */}
      <h3 className="font-bold text-slate-900 mt-6 text-base">Article 6 - Réserve de propriété</h3>
      <p className="text-sm mb-2">
        Les Biens loués demeurent la propriété exclusive et entière du Bailleur pendant toute la durée du contrat, et ce quelle que soit la durée de la location ou le montant cumulé des loyers versés. Les loyers versés par le Preneur constituent exclusivement la contrepartie de la mise à disposition temporaire des Biens et ne sauraient être assimilés, en tout ou partie, au paiement d'un prix d'acquisition. En conséquence, aucun transfert de propriété ne pourra intervenir du seul fait du paiement des loyers, même si le montant cumulé des loyers versés excède la valeur d'acquisition initiale des Biens.
      </p>
      <p className="text-sm mb-2">
        Le Preneur s'interdit de disposer des Biens, notamment par vente, cession, nantissement, gage, mise à disposition à un tiers ou toute autre forme d'aliénation, sans l'accord écrit préalable du Bailleur. Le Preneur s'engage à ne procéder à aucune modification, transformation ou intégration des Biens susceptible d'en altérer la nature ou d'en compromettre la récupération sans l'accord écrit préalable du Bailleur.
      </p>
      <p className="text-sm">
        En cas d'ouverture d'une procédure collective à l'encontre du Preneur, le Bailleur pourra revendiquer les Biens en sa qualité de propriétaire, conformément aux dispositions des articles L.624-9 et suivants du Code de commerce, et notamment l'article L.624-16 alinéa 1er.
      </p>

      {/* Article 7 */}
      <h3 className="font-bold text-slate-900 mt-6 text-base">Article 7 - Interdiction de sous-location et usage</h3>
      <p className="text-sm mb-2">
        Le Preneur s'interdit toute cession du présent contrat. La sous-location, la mise à disposition, le prêt ou toute forme de transfert de jouissance des Biens à un tiers sont interdits sans l'accord écrit préalable du Bailleur.
      </p>
      <p className="text-sm mb-2">
        Toutefois, lorsque le Preneur exerce une activité professionnelle consistant à exploiter les Biens dans le cadre de prestations fournies à ses propres clients (notamment prestations événementielles), l'installation temporaire des Biens sur le site d'un client final est autorisée, sous réserve que :
      </p>
      <ul className="list-disc pl-5 text-sm mb-2">
        <li>Le Preneur demeure seul responsable des Biens ;</li>
        <li>Les Biens ne soient pas sous-loués en tant que tels ;</li>
        <li>Les obligations d'assurance prévues au contrat demeurent pleinement applicables.</li>
      </ul>
      <p className="text-sm">
        Tout manquement pourra entraîner la résiliation immédiate du contrat.
      </p>

      {/* Article 8 */}
      <h3 className="font-bold text-slate-900 mt-6 text-base">Article 8 - Obligations d'assurance et de garde du Preneur</h3>
      <p className="text-sm mb-2">
        Le Preneur s'engage à souscrire, préalablement à la livraison des Biens et pendant toute la durée du contrat, une assurance couvrant les Biens loués en tant que biens confiés ou biens sous garde. Cette assurance devra couvrir notamment les risques suivants :
      </p>
      <ul className="list-disc pl-5 text-sm mb-2">
        <li>Vol, tentative de vol et vandalisme ;</li>
        <li>Incendie, explosion ;</li>
        <li>Dégâts des eaux ;</li>
        <li>Casse ou détérioration accidentelle ;</li>
        <li>Transport, manutention, installation et démontage ;</li>
        <li>Catastrophes naturelles.</li>
      </ul>
      <p className="text-sm mb-2">
        Les Biens devront être assurés pour leur valeur de remplacement au tarif public du Bailleur en vigueur au jour du sinistre. Le Preneur devra fournir au Bailleur, avant toute livraison, une attestation d'assurance en cours de validité mentionnant expressément la couverture des biens confiés ou biens sous garde. <strong>La livraison des Biens est conditionnée à la réception de cette attestation.</strong>
      </p>
      <p className="text-sm mb-2">
        Le Preneur s'engage à maintenir cette assurance pendant toute la durée du contrat et à en justifier à première demande du Bailleur. À défaut, le Bailleur pourra suspendre le contrat ou en prononcer la résiliation de plein droit.
      </p>
      <p className="text-sm mb-2">
        Le Preneur demeure gardien des Biens au sens de l'article 1242 du Code civil et en assume l'entière responsabilité. En cas de perte, vol ou destruction totale des Biens, le contrat sera résilié de plein droit à la date du sinistre, sans préjudice de l'obligation pour le Preneur d'indemniser le Bailleur à hauteur de <strong>100 % de la valeur de remplacement</strong>.
      </p>
      <p className="text-sm mb-2">
        En cas de détérioration partielle, les frais de réparation ou de remplacement seront intégralement à la charge du Preneur. L'indemnisation devra intervenir dans un délai maximum de trente (30) jours à compter de la déclaration du sinistre. Toute franchise, limitation d'indemnisation ou exclusion prévue par le contrat d'assurance du Preneur restera à la charge exclusive de celui-ci. Le Preneur devra notifier tout sinistre au Bailleur dans un délai maximum de vingt-quatre (24) heures.
      </p>
      <p className="text-sm">
        Le Preneur demeure seul responsable de la conformité, de la stabilité et de la sécurité de ses installations lors de l'utilisation des Biens dans le cadre de ses prestations. Le Bailleur ne pourra être tenu responsable des dommages causés à des tiers résultant de l'installation, de la manipulation ou de l'utilisation des Biens par le Preneur.
      </p>

      {/* Article 9 */}
      <h3 className="font-bold text-slate-900 mt-6 text-base">Article 9 - Absence d'option d'achat – Avantage commercial</h3>
      <p className="text-sm mb-2">
        Le présent contrat est conclu exclusivement à titre de location. Aucune option d'achat, promesse de vente ou faculté d'acquisition portant sur les Biens loués n'est consentie au Preneur. Les Biens loués devront être restitués au Bailleur à première demande ou en cas de résiliation, sans possibilité d'en devenir propriétaire.
      </p>
      <p className="text-sm mb-2">
        À titre purement commercial et sans que cela ne constitue une option d'achat ni un mécanisme assimilable à un crédit-bail, le Bailleur pourra accorder au Preneur une remise sur l'acquisition de matériel neuf distinct des Biens loués. Cette remise est calculée à raison de <strong>deux pour cent (2 %) par mois de location</strong> effectivement payé, cumulable dans la limite maximale de <strong>cinquante pour cent (50 %)</strong> du prix public du matériel neuf concerné.
      </p>
      <p className="text-sm mb-2">Cette remise :</p>
      <ul className="list-disc pl-5 text-sm mb-2">
        <li>Ne constitue pas un droit automatique au profit du Preneur ;</li>
        <li>Ne s'impute pas sur les loyers ;</li>
        <li>Ne donne lieu à aucun remboursement ;</li>
        <li>Ne s'applique en aucun cas aux Biens loués ;</li>
        <li>Reste subordonnée à la parfaite exécution du contrat par le Preneur.</li>
      </ul>
      <p className="text-sm">
        Le Bailleur conserve la faculté de définir les conditions commerciales applicables au matériel neuf concerné.
      </p>

      {/* Article 10 */}
      <h3 className="font-bold text-slate-900 mt-6 text-base">Article 10 – Sanctions pour inexécution</h3>
      <p className="text-sm mb-2">
        Outre les cas prévus à l'article 2, le contrat pourra être résilié immédiatement par le Bailleur en cas de non-paiement du loyer, manquement aux obligations d'assurance, sous-location ou dégradation des Biens, après mise en demeure restée sans effet sous 8 jours.
      </p>
      <p className="text-sm mb-2">
        En cas de non-paiement d'un loyer à son échéance, le Bailleur adressera au Preneur une première relance amiable par tout moyen écrit laissant trace. À défaut de régularisation dans un délai de huit (8) jours suivant la mise en demeure, le contrat pourra être résilié de plein droit, sans formalité judiciaire.
      </p>
      <p className="text-sm mb-2">La résiliation entraînera :</p>
      <ul className="list-disc pl-5 text-sm mb-2">
        <li>L'exigibilité immédiate des sommes échues et non réglées ;</li>
        <li>L'obligation pour le Preneur de restituer immédiatement les Biens ;</li>
        <li>Le droit pour le Bailleur de procéder à la récupération des Biens aux frais exclusifs du Preneur.</li>
      </ul>
      <p className="text-sm mb-2">
        Le Preneur autorise expressément le Bailleur ou tout mandataire désigné à accéder à ses locaux professionnels aux fins de récupération des Biens, sous réserve du respect des dispositions légales applicables. En cas de non-restitution dans un délai de huit (8) jours suivant la résiliation, une indemnité d'occupation sera due.
      </p>
      <p className="text-sm mb-2">
        Conformément à l'article L.441-10 du Code de commerce, tout retard de paiement entraînera l'application d'une <strong>indemnité forfaitaire pour frais de recouvrement de quarante (40) euros</strong> par échéance impayée, sans préjudice des frais supplémentaires réellement engagés. En outre, une <strong>indemnité forfaitaire égale à dix pour cent (10 %)</strong> des sommes impayées sera due à titre de clause pénale.
      </p>
      <p className="text-sm">
        Le Bailleur se réserve le droit de poursuivre l'exécution forcée des obligations du Preneur par toute voie judiciaire.
      </p>

      {/* Article 11 */}
      <h3 className="font-bold text-slate-900 mt-6 text-base">Article 11 - Limitation de responsabilité</h3>
      <p className="text-sm mb-2">
        Le Bailleur ne pourra être tenu responsable des pertes indirectes, pertes d'exploitation, pertes commerciales, perte de chiffre d'affaires, perte de clientèle, atteinte à l'image, ni de tout autre préjudice immatériel subi par le Preneur ou par des tiers du fait de l'utilisation des Biens.
      </p>
      <p className="text-sm mb-2">
        La responsabilité du Bailleur, toutes causes confondues, est strictement limitée au montant des loyers perçus au titre du mois au cours duquel le fait générateur est intervenu.
      </p>
      <p className="text-sm">
        Le Bailleur ne saurait être tenu responsable en cas d'utilisation non conforme des Biens, d'installation inadaptée ou de manipulation par le Preneur ou ses prestataires. Cette limitation ne s'applique pas en cas de faute lourde ou dolosive du Bailleur.
      </p>

      {/* Article 12 */}
      <h3 className="font-bold text-slate-900 mt-6 text-base">Article 12 - Assistance technique</h3>
      <p className="text-sm">
        Toute demande d'assistance technique, paramétrage ou configuration à distance ou sur site fera l'objet d'une facturation au tarif de <strong>99 € HT par heure</strong>. Toute heure commencée est due.
      </p>

      {/* Article 13 */}
      <h3 className="font-bold text-slate-900 mt-6 text-base">Article 13 - Litiges</h3>
      <p className="text-sm">
        Toutes contestations relatives au présent contrat seront soumises à la compétence du tribunal compétent. Le présent contrat est régi par le droit français.
      </p>

      {/* Signature */}
      <div className="mt-8 p-4 bg-slate-100 rounded-lg">
        <p className="text-sm text-slate-600 text-center">
          Fait à Marignane, le <strong>{today}</strong>, en version électronique.
        </p>
        <div className="grid grid-cols-2 gap-8 mt-6">
          <div className="text-center">
            <p className="text-xs text-slate-500 mb-2">Le Bailleur</p>
            <p className="text-sm font-semibold mb-2">KF DIFFUSION</p>
            <img 
              src={`${window.location.origin}/api/static/signature_thierry_fredj.png`}
              alt="Signature KF DIFFUSION"
              className="h-16 mx-auto object-contain"
            />
            <img 
              src={`${window.location.origin}/api/static/tampon_kf_diffusion.png`}
              alt="Tampon KF DIFFUSION"
              className="h-24 mx-auto object-contain mt-1"
            />
          </div>
          <div className="text-center">
            <p className="text-xs text-slate-500 mb-2">Le Preneur</p>
            <p className="text-sm font-semibold">{customerName || 'Client'}</p>
            <p className="text-xs text-slate-500 mt-1">{customerData?.email}</p>
            <div className="mt-3 border-t border-dashed border-slate-400 pt-2">
              <p className="text-xs text-slate-400 italic">Signature électronique via PandaDoc</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContractDisplay;
